import CustomTooltip from '../../shared/CustomTooltip';
import BlockIcon from '@mui/icons-material/Block';
import DoneIcon from '@mui/icons-material/Done';
import {
    Avatar,
    Box,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { MRT_ColumnDef } from 'mantine-react-table';
import React from 'react';
import { CustomChip } from '../../../layout/styledcomponents/CustomChip';
import GenericTable, { LinkType } from '../../shared/GenericTable';

export default function AllGuestsComponent(params: any) {
    const { data: getGuests } = params;
    const theme = useTheme();

    const columns: MRT_ColumnDef<any>[] = [
        {
            accessorKey: 'name',
            header: 'Guest Company',
            size: 500,
            filterFn: 'fuzzy',
            mantineTableBodyCellProps: {
                style: {
                    padding: 0,
                },
            },
            Cell: ({ row, cell }) => {
                const isMobile = useMediaQuery('(max-width:600px)');
                const value = cell.getValue<string>();
                return (
                    <List>
                        <ListItem sx={{ padding: '0!important' }}>
                            {!isMobile && (
                                <ListItemAvatar>
                                    <Avatar
                                        sx={{
                                            bgcolor: theme.palette.faded.main,
                                        }}
                                    >
                                        {value?.charAt(0)}
                                        {row.original?.lastName?.charAt(0)}
                                    </Avatar>
                                </ListItemAvatar>
                            )}
                            <ListItemText
                                primary={<Typography>{value}</Typography>}
                                secondary={
                                    <Typography
                                        sx={{
                                            fontSize: '12px',
                                        }}
                                    >
                                        {row.original?.account?.email}
                                    </Typography>
                                }
                            />
                        </ListItem>
                    </List>
                );
            },
        },
        {
            accessorKey: 'activeUsers',
            header: 'Active Users',
            filterFn: 'betweenInclusive',
            size: 120,
            Cell: ({ cell }) => <span>{cell.getValue<number>()}</span>,
        },
        {
            accessorKey: 'isActive',
            accessorFn: (row) => (row.isActive ? 'Enabled' : 'Disabled'),
            header: 'Status',
            size: 130,
            filterVariant: 'select',
            filterFn: (row, _columnId, filterValue) => {
                if (!filterValue) return true;
                return row.getValue<string>('isActive') === filterValue;
            },
            mantineFilterSelectProps: {
                data: [
                    { label: 'Enabled', value: 'Enabled' },
                    { label: 'Disabled', value: 'Disabled' },
                ],
                placeholder: 'Filter by Status',
                clearable: true,
            },
            Cell: ({ cell }) => {
                const isMobile = useMediaQuery('(max-width:600px)');
                const isIpad = useMediaQuery('(max-width:1024px)');
                const value = cell.getValue<string>() === 'Enabled';

                if (isMobile || isIpad) {
                    return value ? (
                        <CustomTooltip title='Enabled'>
                            <DoneIcon
                                sx={{ color: theme.palette.textAccent.main }}
                            />
                        </CustomTooltip>
                    ) : (
                        <CustomTooltip title='Disabled'>
                            <BlockIcon />
                        </CustomTooltip>
                    );
                }

                return (
                    <CustomChip
                        label={
                            <Typography
                                color={value ? 'green' : 'red'}
                                sx={{
                                    fontSize: '12px',
                                }}
                            >
                                {value ? 'Enabled' : 'Disabled'}
                            </Typography>
                        }
                        color={value ? 'green' : 'red'}
                        variant='outlined'
                    />
                );
            },
        },
    ];

    return (
        <Box sx={{ height: 700, width: '100%' }}>
            <GenericTable
                columns={columns}
                data={getGuests || []}
                tableName='7DAY-Guests-List'
                loading={!getGuests}
                linkType={LinkType.Guest}
                linkState={{ name: 'viewGuest' }}
            />
        </Box>
    );
}
